const MARKET_TYPE_MAP = {
    load: 1,
    lorry: 2,
    loads: 1,
    lorries: 2
};
const MARKET_TYPE = {
    LOADS: "loads",
    LORRIES: "lorries",
    LOAD: "load",
    Lorry: "lorry"
};
var MarketPlaceType;
(function (MarketPlaceType) {
    MarketPlaceType["LOAD"] = "load";
    MarketPlaceType["LORRY"] = "lorry";
})(MarketPlaceType || (MarketPlaceType = {}));

export { MARKET_TYPE, MARKET_TYPE_MAP, MarketPlaceType };
//# sourceMappingURL=market.js.map
